import { useCallback, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useUnmount, useUpdateEffect } from "react-use";
import debounce from "lodash/debounce";
import localizationService from "~/services/LocalizationService";
import { editPersonalizedConfigOptions } from "~/store/actions/actions.personalizedConfigOptions";
import { getTimezoneInfo } from "~/store/selectors/selector.configOptions";

export const useTimezoneListener = () => {
  const dispatch = useDispatch();
  const info = useSelector(getTimezoneInfo);
  const { time_timezone, time_timezone_autodetect } = info;

  const [isListening, setIsListening] = useState(() => false);

  const debouncedUpdate = useRef(
    debounce((userTimezone) => {
      dispatch(editPersonalizedConfigOptions({ time_timezone: userTimezone }));
    }, 2000)
  ).current;

  useUpdateEffect(() => {
    if (isListening && time_timezone_autodetect) {
      localizationService.update({
        timezone_autodetect: true,
      });
      if (time_timezone !== localizationService.timezone) {
        debouncedUpdate?.cancel();
        debouncedUpdate(localizationService.timezone);
      }
    }
  }, [isListening, time_timezone, time_timezone_autodetect]);

  useUnmount(() => {
    if (debouncedUpdate && typeof debouncedUpdate.cancel === "function") {
      debouncedUpdate.cancel();
    }
  });

  return useCallback(() => {
    setIsListening(true);
  }, []);
};
